module.exports = __webpack_public_path__ + "img/icon-warning-localization.76283756.svg";